import type { FlowPoint } from './K1HierarchyEdge.types';

export const EDGE_ROUTE_PADDING = 28;

export function getRoundedOrthogonalPath(points: FlowPoint[], radius = 12) {
  const compactPoints = points.filter(
    (point, index) => index === 0 || point.x !== points[index - 1].x || point.y !== points[index - 1].y,
  );

  if (compactPoints.length < 2) return '';

  let path = `M ${compactPoints[0].x},${compactPoints[0].y}`;

  for (let i = 1; i < compactPoints.length - 1; i += 1) {
    const prev = compactPoints[i - 1];
    const curr = compactPoints[i];
    const next = compactPoints[i + 1];
    const prevDistance = Math.hypot(curr.x - prev.x, curr.y - prev.y);
    const nextDistance = Math.hypot(next.x - curr.x, next.y - curr.y);
    const cornerRadius = Math.min(radius, prevDistance / 2, nextDistance / 2);

    if (!cornerRadius || !Number.isFinite(cornerRadius)) {
      path += ` L ${curr.x},${curr.y}`;
      continue;
    }

    const beforeCorner = {
      x: curr.x - ((curr.x - prev.x) / prevDistance) * cornerRadius,
      y: curr.y - ((curr.y - prev.y) / prevDistance) * cornerRadius,
    };
    const afterCorner = {
      x: curr.x + ((next.x - curr.x) / nextDistance) * cornerRadius,
      y: curr.y + ((next.y - curr.y) / nextDistance) * cornerRadius,
    };

    path += ` L ${beforeCorner.x},${beforeCorner.y} Q ${curr.x},${curr.y} ${afterCorner.x},${afterCorner.y}`;
  }

  const last = compactPoints[compactPoints.length - 1];
  return `${path} L ${last.x},${last.y}`;
}
